/**
 * Sprint 23 — themed labels resolver.
 *
 * The single point every workforce-related label flows through. Reads the active
 * theme (via {@link useLanguageTheme}) and returns that theme's label record.
 * Components call `const labels = useThemedLabels()` and read `labels.collective`,
 * `labels.addAction`, etc. — never hard-coded vocabulary.
 */

import { useLanguageTheme } from "./use-language-theme";
import { LANGUAGE_THEME_LABELS, type ThemedLabels } from "../lib/themed-labels";

export function useThemedLabels(): ThemedLabels {
  const { theme } = useLanguageTheme();
  return LANGUAGE_THEME_LABELS[theme];
}
